import { Link, useParams } from 'react-router-dom';
import '../App.css';
import Header from '../components/Header';
import ProgressStageCarousel from '../components/ProgressStageCarousel';
import { Helmet } from 'react-helmet-async';
import { getProgressTimeline } from '../data/developmentProgressTimelines';

function DevelopmentProgressTimeline() {
  const { slug } = useParams<{ slug: string }>();
  const timeline = slug ? getProgressTimeline(slug) : undefined;

  if (!timeline) {
    return (
      <div className="page">
        <Header />
        <main className="content-section development-detail-page">
          <div className="development-detail-container">
            <h1>Progress timeline not found</h1>
            <p>
              <Link to="/developments" className="nurse-care-link">
                Back to developments
              </Link>
            </p>
          </div>
        </main>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>
          {timeline.developmentName} progress timeline | Graham Care
        </title>
        <meta
          name="description"
          content={`Construction progress timeline for ${timeline.developmentName}, ${timeline.location}.`}
        />
      </Helmet>

      <div className="page">
        <a href="#main-content" className="skip-link">
          Skip to main content
        </a>
        <Header />

        <main id="main-content">
          <section className="content-section development-progress-page">
            <div className="development-progress-container">
              <p className="development-detail-breadcrumb">
                <Link to="/developments" className="nurse-care-link">
                  Developments
                </Link>
              </p>
              <h1>Progress timeline</h1>
              <p className="development-progress-intro">
                {timeline.developmentName}, {timeline.location}
              </p>

              {timeline.stages.length > 0 ? (
                <ol className="development-progress-timeline">
                  {timeline.stages.map((stage) => (
                    <li key={`${stage.date}-${stage.title}`} className="development-progress-stage">
                      <div className="development-progress-stage__header">
                        <p className="development-progress-stage__date">{stage.date}</p>
                        <h2 className="development-progress-stage__title">{stage.title}</h2>
                      </div>
                      <div
                        className={`development-progress-stage__content${
                          stage.body ? ' development-progress-stage__content--with-body' : ''
                        }`}
                      >
                        {stage.items && stage.items.length > 0 ? (
                          <ProgressStageCarousel items={stage.items} stageTitle={stage.title} />
                        ) : (
                          stage.image && (
                            <figure className="development-progress-stage__figure">
                              <img
                                src={stage.image}
                                alt=""
                                loading="lazy"
                                className="development-progress-stage__image"
                              />
                            </figure>
                          )
                        )}
                        {stage.body && (
                          <div className="development-progress-stage__text">
                            <h3 className="development-progress-stage__update-heading">
                              {stage.date} Progress Update
                            </h3>
                            <p className="development-progress-stage__body">{stage.body}</p>
                          </div>
                        )}
                      </div>
                    </li>
                  ))}
                </ol>
              ) : (
                <p>Progress updates will be published here soon.</p>
              )}
            </div>
          </section>
        </main>

        <footer className="footer">
          <section className="footer__enquiry">
            <div className="footer__enquiry-container">
              <Link to="/contact-us" className="footer__enquiry-link">
                Enquire about Graham Care <span className="footer__arrow">▶</span>
              </Link>
            </div>
          </section>
          <div className="footer__container">
            <section className="contact-section">
              <div className="contact-section__content">
                <p>Graham Care Ltd, KT15 1HH</p>
                <p>Copyright © Graham Care Ltd</p>
              </div>
            </section>
          </div>
        </footer>
      </div>
    </>
  );
}

export default DevelopmentProgressTimeline;
